const name = 'facturacion'
const path = '/facturacion';

export default [
  {
    path: `${path}`,
    name: `${name}`,
    component: () => import('./ViewListFacturacion.vue'),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: `${path}/:id`,
    name: 'BillingDetails',
    component: () => import('./ViewFacturacionDetails.vue'),
    meta: { requiresAuth: true },
    props: true,
  },
];
